import { MESSAGES_TO_SM } from '../../constants.js';

export function messageToStateMachine(message) {
  return {
    type: MESSAGES_TO_SM.MESSAGE_TO_SM,
    message: message
  };
}

export function sendMessageNoAvailable(userName, userID, notReadyID, conversationID,timeInPreview) {
  return {
    type: MESSAGES_TO_SM.NO_AVAILABLE_EVENT,
    userName: userName,
    userID: userID,
    notReadyID: notReadyID,
    conversationID: conversationID,
    TimePreview: timeInPreview
  };
}

export function sendMessageAgentReady() {
  return {
    type: MESSAGES_TO_SM.AGENT_READY
  };
}

export function retryFirstCall(userName, userID) {
  return {
    type: MESSAGES_TO_SM.RETRY_FIRST_CALL,
    userName: userName,
    userID: userID,
  };
}

export function messageToSupervisor(message, supervisor) {
  return {
    type: MESSAGES_TO_SM.MESSAGE_TO_SUPERVISOR,
    message: message,
    supervisor: supervisor,
  };
}

export function messageChangeState() {
  return {
    type: MESSAGES_TO_SM.CHANGE_STATE
  };
}

export function messageMarksCall(marks,callOutId) {
  return {
    type: MESSAGES_TO_SM.MARKS_CALL,
    marks: marks,
    callOutId: callOutId
  };
}

export function messageApiRequest(subaction, json, expectsResponse) {
  return {
    type: MESSAGES_TO_SM.API_REQUEST,
    subaction: subaction,
    json: json,
    expectsResponse: expectsResponse
  };
}

export function messageHangUp(subaction,callOutId,maxTime) {
  return {
    type: MESSAGES_TO_SM.HANG_UP,
    subaction: subaction,
    callOutId:callOutId,
    calloutMaxTime:maxTime
  }; 
}

export function updateInfoCall(callKey_A, camID_A, dataCall_A, callOutId_A) {
  return {
    type: MESSAGES_TO_SM.UPDATE_DATA_CALL,
    callKey: callKey_A,
    dataCall: dataCall_A,
    camId: camID_A,
    CallOutId: callOutId_A
  };
}

export function messageTransferCall(data) {
  return {
    type: MESSAGES_TO_SM.TRANSFER_CALL,
    data: data
  };
}

export function messageAssistedTransferCall(process,data) {
  return {
    type: MESSAGES_TO_SM.ASSISTED_TRANSFER_CALL,
    process: process,
    data: data
  };
}

export function manualCall(data) {
  return {
    type: MESSAGES_TO_SM.MANUAL_CALL,
    data: data
  };
}

export function messageOngoingCallIvr(id) {
  return {
    type: MESSAGES_TO_SM.ONGOING_CALL_IVR,
    id: id
  };
}

export function aceptedChat(data) {
  return{
    type: MESSAGES_TO_SM.ACEPTED_CHAT,
    data: data
  }
}

export function endConversationChat(data) {
  return {
    type: MESSAGES_TO_SM.END_CONVERSATION_CHAT,
    data: data
  }
}

export function spamConversation(data) {
  return {
    type: MESSAGES_TO_SM.SPAM_CONVERSATION,
    data: data
  }
}

export function unassignConversation(data) {
  return {
    type: MESSAGES_TO_SM.UNASSIGN_CONVERSATION,
    data: data
  }
}

export function discardConversation(data) {
  return {
    type: MESSAGES_TO_SM.DISCARD_CONVERSATION,
    data: data
  }
}

export function onSendUnifiedResponse(data) {
  return {
    type: MESSAGES_TO_SM.SEND_UNIFIED_RESPONSE,
    data: data
  }
}

export function onSendExternalUnifiedResponse(data) {
  return {
    type: MESSAGES_TO_SM.SEND_EXTERNAL_UNIFIED_RESPONSE,
    data: data
  }
}

export function sendDispositionOnWrapUp(data) {
  return {
    type: MESSAGES_TO_SM.SEND_DISPOSITION,
    data: data
  }
}

export function selectedMessage(data) {
  return {
    type: MESSAGES_TO_SM.SELECTED_MESSAGE,
    data: data
  }
}

export function changeStateMultimedia(data) {
  return {
    type: MESSAGES_TO_SM.CHANGE_STATE_MULTIMEDIA,
    data: data
  }
}

export function changeStateMultimediaAll(data) {
  return {
    type: MESSAGES_TO_SM.CHANGE_STATE_MULTIMEDIA_ALL,
    data: data
  }
}

export function sendChangeDialingMode(data) {
   return {
     type: MESSAGES_TO_SM.CHANGE_DIALINGMODE_SCH,
     data: data
   };
}
export function actionPreviewRecord(data) {
  return {
    type: MESSAGES_TO_SM.PREVIEW_RECORD,
    data:data
  };
}

export function actionPreviewTransfer(subaction,agent, callOutId) {
  return {
    type: MESSAGES_TO_SM.PREVIEW_TRANSFER,
    subaction: subaction,
    agent: agent,
    callOutId: callOutId
  };
}

export function actionResponseTransfer(agent, response) {
  return {
    type: MESSAGES_TO_SM.SEND_RESPONSE_TRANSFER,
    agent: agent,
    response: response
  };
}
export function getMoreMessages(data) {
  return {
    type: MESSAGES_TO_SM.GET_MORE_MESSAGES,
    data: data
  };
}

export function acceptChatSaveTime(data){
  return {
    type: MESSAGES_TO_SM.ACCEPT_CHAT_SAVE_TIME,
    data: data
  }
}

export function messageApiRequestANIList(subaction, camId, expectsResponse) {
  return {
    type: MESSAGES_TO_SM.API_REQUEST_ANI_LIST,
    subaction: subaction,
    campId: camId,
    expectsResponse: expectsResponse
  };
}

export function getRecordCallPermission(subaction, camId, expectsResponse) {
  return {
    type: MESSAGES_TO_SM.GET_RECORD_CALL_PERMISSION,
    subaction: subaction,
    campId: camId,
    expectsResponse: expectsResponse
  };
}
export function messageGetPreviewCampaigns(subaction) {
  return {
    type: MESSAGES_TO_SM.GET_PREVIEW_CAMPAIGNS,
    subaction: subaction,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_messages_to_SM.js